var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboar02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 20.8417H25.6248",
    stroke: "#33CCCC",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 27.675H21.149",
    stroke: "#33CCCC",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0832 10.25H23.9165C27.3332 10.25 27.3332 8.54166 27.3332 6.83332C27.3332 3.41666 25.6248 3.41666 23.9165 3.41666H17.0832C15.3748 3.41666 13.6665 3.41666 13.6665 6.83332C13.6665 10.25 15.3748 10.25 17.0832 10.25Z",
    stroke: "#0C111D",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 6.86749C33.0221 7.17499 35.875 9.27624 35.875 17.0833V27.3333C35.875 34.1667 34.1667 37.5833 25.625 37.5833H15.375C6.83333 37.5833 5.125 34.1667 5.125 27.3333V17.0833C5.125 9.29333 7.97792 7.17499 13.6667 6.86749",
    stroke: "#0C111D",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboar02);
export default __webpack_public_path__ + "static/media/clipboar02.7a94110197bc0cfa0ea986ba5ad2e6a6.svg";
export { ForwardRef as ReactComponent };